export default __webpack_public_path__ + "static/media/Poem.a9542555.jpg";